var React = require('react');

function GalleryPrevButton (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.02192 5.96967C0.729023 6.26256 0.729023 6.73744 1.02192 7.03033L5.79489 11.8033C6.08778 12.0962 6.56265 12.0962 6.85555 11.8033C7.14844 11.5104 7.14844 11.0355 6.85555 10.7426L2.61291 6.5L6.85555 2.25736C7.14844 1.96447 7.14844 1.48959 6.85555 1.1967C6.56265 0.903806 6.08778 0.903806 5.79489 1.1967L1.02192 5.96967ZM1.55225 7.25H25.5522V5.75H1.55225V7.25Z","fill":"#194550"}));
}

GalleryPrevButton.defaultProps = {"width":"26","height":"13","viewBox":"0 0 26 13","fill":"none"};

module.exports = GalleryPrevButton;

GalleryPrevButton.default = GalleryPrevButton;
